export default __webpack_public_path__ + "static/media/blog2.3a268a56.png";